import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'
import baseButtonDefaults from '../BaseButton/BaseButton.defaults'
import baseLabelDefaults from '../BaseLabel/BaseLabel.defaults'

export default {

  ...cloneDeep(baseDefaults),

  label: cloneDeep(baseLabelDefaults),

  button: Object.assign({}, cloneDeep(baseButtonDefaults), {
    fullwidth: true,
    text: "Confirm order"
  }), 

  baseFields: {
    variant: "solid",
  },
  
  productId: '',
  preferredPricingOptionId: '',
  orderBump: {
    buttonText: 'Yes, I will take it now!'
  },

  customerFields: {
    email: {
      label: '',
      placeholder: '',
      required: true,
      enabled: true
    },
  },

  shippingFields: {
    active: false,
    first_name: {
      label: '',
      placeholder: '',
      required: true,
      enabled: true
    },
    last_name: {
      label: '',
      placeholder: '',
      required: true,
      enabled: true
    },
    telephone: {
      label: '',
      placeholder: '',
      required: false,
      enabled: false
    },
    addressLine1: {
      label: '',
      placeholder: '',
      required: true,
      enabled: true
    },
    stateProvince: {
      label: '',
      placeholder: '',
      required: true,
      enabled: true
    },
    postalCode: {
      label: '',
      placeholder: '',
      required: true,
      enabled: true
    },
    city: {
      label: '',
      placeholder: '',
      required: true,
      enabled: true
    },
    country: {
      label: '',
      placeholder: '',
      custom: false,
      customCountries: undefined,
      required: true,
      enabled: true
    }
  },

  billingFields: {
    active: true,
    same_as_shipping: {
      label: '',
      placeholder: '',
      required: false,
      enabled: false
    },
    first_name: {
      label: '',
      placeholder: '',
      required: false,
      enabled: false
    },
    last_name: {
      label: '',
      placeholder: '',
      required: false,
      enabled: false
    },
    telephone: {
      label: '',
      placeholder: '',
      required: false,
      enabled: false
    },
    addressLine1: {
      label: '',
      placeholder: '',
      required: false,
      enabled: false
    },
    stateProvince: {
      label: '',
      placeholder: '',
      required: false,
      enabled: false 
    },
    postalCode: {
      label: '',
      placeholder: '',
      required: false,
      enabled: false
    },
    city: {
      label: '',
      placeholder: '',
      required: false,
      enabled: false
    },
    country: {
      label: '',
      placeholder: '',
      custom: false,
      customCountries: undefined,
      required: true,
      enabled: true
    }
  },

  preferredPaymentProcessor: 'stripe',
  preferredPaymentMethod: 'card',

  paymentSummary: {
    couponEnabled: true
  }
  
}